'use strict';

var React = require('react');

//Components
var PersonalInfo = require('./PersonalInfo.jsx');
var ContactDetails = require('./ContactDetails.jsx');
var Tfn = require('../Common/Tfn.jsx');
var Occupation = require('./Occupation.jsx');
var BusinessAddress = require('./Address.jsx');
var Address = require('./Address.jsx');
var Residence = require('./Residence.jsx');
var TaxResidence = require('./TaxResidence.jsx');
var TextInput = require('../Common/TextInput.jsx');
var PowerOfAttorney = require('./PowerOfAttorney.jsx').default;
var AccountDesignation = require('./AccountDesignation.jsx').default;
var AustralianTaxResident = require('./AustralianTaxResident.jsx').default;
var SourceOfFund = require('./SourceOfFund.jsx');
var SourceOfWealth = require('./SourceOfWealth.jsx');

//Constants
var YourDetailsConstants = require('../../constants/YourDetailsConstants');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var YesNoValues = ApplicationConstants.YesNoValues;

//Stores
var YourDetailsStore = require('../../stores/YourDetailsStore');
//Action
var Action = require('../../actions/YourDetailsActions');

function getStateFromStores() {
    return {
        titleList: YourDetailsStore.getTitleList(),
        addressInfo: YourDetailsStore.getAddressInfo(),
        errorList: YourDetailsStore.getErrorList(),
        tfnExemptionList: YourDetailsStore.getTfnExemptionList(),
        yourDetailsData: YourDetailsStore.getYourDetailsData()
    };
}

var SoleTraderInvestment = React.createClass({

    getInitialState: function () {
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    updateYourDetails: function (event) {
        Action.updateYourDetailsData(event.target.model, event.target.id, event.target.value);
    },

    render: function () {
        var hasTfnExemption = this.state.yourDetailsData ? this.state.yourDetailsData.hasTfnExemption : '';
        var hasTfnExemptionReadonly = this.state.yourDetailsData ? this.state.yourDetailsData.hasTfnExemptionReadonly : false;
        var tfnNumber = this.state.yourDetailsData ? this.state.yourDetailsData.tfnNumber : '';
        var tfnNumberReadonly = this.state.yourDetailsData ? this.state.yourDetailsData.tfnNumberReadonly : false;
        var tfnExemptionReason = this.state.yourDetailsData ? this.state.yourDetailsData.tfnExemptionReason : '';
        var tfnExemptionReasonReadonly = this.state.yourDetailsData ? this.state.yourDetailsData.tfnExemptionReasonReadonly : '';
        var showTaxResidenceQuestion = !(this.state.yourDetailsData.isOtherCountryTaxResident === YesNoValues.YES &&
            this.state.yourDetailsData.isOtherCountryTaxResidentReadonly);
        var showCitizenshipQuestion = !(this.state.yourDetailsData.isCitizenOfOtherCountry === YesNoValues.YES &&
            this.state.yourDetailsData.isCitizenOfOtherCountryReadonly);

        return (
                <div>
                    <PersonalInfo data={this.state.yourDetailsData}
                                  titleList={this.state.titleList}
                                  errorList={this.state.errorList} />
                    <Address data={this.state.addressInfo}
                             errorList={this.state.errorList}                             
                             productId={this.props.productId} />
                    <ContactDetails data={this.state.yourDetailsData}
                                    productId={this.props.productId}
                                    accountType={ApplicationConstants.AccountTypeCodes.SOLE_TRADER}
                                    errorList={this.state.errorList}
                                    content={this.props.content} />
                    <Tfn productId={this.props.productId}
                         accountType={this.props.accountType}
                         hasTfnExemption={hasTfnExemption}
                         hasTfnExemptionReadonly={hasTfnExemptionReadonly}
                         tfnNumber={tfnNumber}
                         tfnNumberReadonly={tfnNumberReadonly}
                         tfnExemptionReason={tfnExemptionReason}
                         tfnExemptionReasonReadonly={tfnExemptionReasonReadonly}
                         tfnExemptionList={this.state.tfnExemptionList}
                         tfnConsentFlag={this.state.yourDetailsData.tfnConsentFlag}
                         tfnWithConsent={this.state.yourDetailsData.tfnWithConsent}
                         errorList={this.state.errorList} />
                    <Residence data={this.state.yourDetailsData}
                               type={YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE}
                               countryLabel="What is your main country of residence?"
                               errorList={this.state.errorList}
                               showQuestion={false} />
                    <AustralianTaxResident 
                          data={this.state.yourDetailsData} 
                          section={this.props.section}
                          errorList = {this.state.errorList}/>
                    <TaxResidence data={this.state.yourDetailsData}
                               countryLabel="Select country of tax residence"
                               errorList={this.state.errorList}
                               showQuestion={showTaxResidenceQuestion} />
                    <Residence data={this.state.yourDetailsData}
                               type={YourDetailsConstants.ResidenceType.CITIZENSHIP}
                               errorList={this.state.errorList}
                               showQuestion={showCitizenshipQuestion} />
                    <TextInput label="Full business name"
                               id="businessName"
                               value={this.state.yourDetailsData.businessName}
                               onBlur={this.updateYourDetails}
                               model="businessName"
                               errorList={this.state.errorList}
                               isDisabled={this.state.yourDetailsData.businessNameReadonly} />
                    <BusinessAddress data={this.state.yourDetailsData.businessAddress}
                                     accountType={ApplicationConstants.AccountTypeCodes.SOLE_TRADER}
                                     withPostalAddress={false}
                                     type={YourDetailsConstants.Values.BUSINESS}
                                     section="ydSoleTraderBusiness"
                                     errorList={this.state.errorList} />
                    <TextInput label={'ABN (if any)'}
                               id={'abn'}
                               value={this.state.yourDetailsData.abn}
                               onBlur={this.updateYourDetails}
                               model="abn"
                               errorList={this.state.errorList}
                               isDisabled={this.state.yourDetailsData.abnReadonly} />
                    <Occupation data={this.state.yourDetailsData}
                                errorList={this.state.errorList} />
                    <SourceOfFund id="sourceOfFund"
                            data={this.state.yourDetailsData}
                            section={this.props.section}
                            errorList={this.state.errorList} />
                    <SourceOfWealth id="sourceOfWealth"
                            data={this.state.yourDetailsData}
                            section={this.props.section}
                            errorList={this.state.errorList} />
                    <PowerOfAttorney data={this.state.yourDetailsData.isPowerOfAttorney} />
                    <AccountDesignation data={this.state.yourDetailsData} errorList={this.state.errorList} />
                </div>
        );
    }
});

module.exports = SoleTraderInvestment;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/SoleTraderInvestment.jsx